import _isNil from "lodash/isNil";
import { getPairsForFiles } from 'utils/fastqUtils';
import createMemoizedSelector from '../createMemoizedSelector';
var getPairMatchesAreValid = function getPairMatchesAreValid(secondaryAnalysisId) {
  return function (state) {
    if (_isNil(state[secondaryAnalysisId])) return null;
    var files = state[secondaryAnalysisId].files;
    var pairs;
    try {
      pairs = getPairsForFiles(files.data);
    } catch (e) {
      if (e.message === 'Invalid number of files per sulibrary') {
        // No valid return when pairs are invalid
        return null;
      }
      throw e;
    }
    return pairs;
  };
};
export default createMemoizedSelector(getPairMatchesAreValid);